


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { IPark } from '@/models/IPark.model.ts';
import { ParksAPI } from '@/apis/parks.api';
import { UsersAPI } from '@/apis/users.api';

@Component({
    components: { },
})
export default class TabParksView extends Vue {

  @Prop() public parks!: IPark[];

  private first = false;

  public async downloadJSON() {
    const userApi = new UsersAPI();
    const users = await userApi.getAll();

    var jsonData = JSON.parse(JSON.stringify(users)+'');
    var content = JSON.stringify(jsonData);
    var fileName =  'users.json';
    var contentType =  'text/plain'
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

}
